import Axios, { AxiosResponse } from "axios";

class SecurityServiceClass {
  public twoFaSetup(): Promise<AxiosResponse> {
    return Axios.post("/api/security/two_factor_authentications/setup");
  }

  public twoFaConfirm({ code_2fa }): Promise<AxiosResponse> {
    return Axios.post("/api/security/two_factor_authentications/confirm", {
      code_2fa,
    });
  }

  public twoFaUnlock({ code_2fa }): Promise<AxiosResponse> {
    return Axios.post("/api/security/two_factor_authentications/unlock", {
      code_2fa,
    });
  }

  public twoFaRegenerate(): Promise<AxiosResponse> {
    return Axios.post("/api/security/two_factor_authentications/regenerate");
  }

  public twoFaDisable(): Promise<AxiosResponse> {
    return Axios.post("/api/security/two_factor_authentications/disable");
  }

  public twoFaStatus(): Promise<AxiosResponse> {
    return Axios.get("/api/security/two_factor_authentications");
  }
}

const SecurityService = new SecurityServiceClass();

export default SecurityService;
